const BASE_URL = "https://api.dev.auxo.dk/public/content";

export async function fetchCollection(collectionName) {
  try {
    const response = await fetch(`${BASE_URL}/${collectionName}`);
    if (!response.ok) throw new Error(`Failed to fetch ${collectionName}`);
    return await response.json();
  } catch (error) {
    console.error(error);
    return [];
  }
}

export async function fetchBySlug(slug, lang = "da") {
  try {
    const response = await fetch(`https://api.dev.auxo.dk/public/by-slug/${lang}/${slug}`);
    if (!response.ok) return null;
    return await response.json();
  } catch (error) {
    return null;
  }
}
